module.exports = __webpack_public_path__ + "static/media/4.ed998be5.png";